import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 19385,
  clicks: 423,
  adsSpendDollars: 1536,
  budgetDollars: 1800,
  salesDollars: 5780,
  bestEstimateRoas: 3.76,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.85,
  newCustomersAcquired: 14,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
